import { match } from 'ts-pattern';

import { formatCurrencyFromCents } from '@/shared/lib/format-utils';

import type { BillingHistoryEntry } from '../model/billing-history.types';
import { formatBillingHistoryPerformedBy } from './format-billing-history-performed-by';

export function formatBillingHistoryLine(entry: BillingHistoryEntry): string {
    const performedBy = formatBillingHistoryPerformedBy(entry.performedByName);

    return match(entry)
        .with(
            { type: 'PAYMENT_APPLIED' },
            ({ amountCents }) =>
                `${performedBy} applied ${formatCurrencyFromCents(amountCents)} payment`,
        )
        .with(
            { type: 'PAYMENT_RECORDED' },
            ({ sessionCount }) =>
                `${performedBy} applied payment to ${sessionCount} ${sessionCount === 1 ? 'session' : 'sessions'}`,
        )
        .with({ type: 'REFUND_ISSUED' }, ({ amountCents }) =>
            amountCents === null
                ? `${performedBy} refunded payment`
                : `${performedBy} refunded ${formatCurrencyFromCents(amountCents)}`,
        )
        .with(
            { type: 'SERVICE_CHANGED' },
            ({ fromCode, toCode }) =>
                `${performedBy} changed service from ${fromCode} to ${toCode}`,
        )
        .with(
            { type: 'FEE_CHANGED' },
            ({ fromCents, toCents }) =>
                `${performedBy} changed fee from ${formatCurrencyFromCents(fromCents)} to ${formatCurrencyFromCents(toCents)}`,
        )
        .exhaustive();
}
